import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../redux/store';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = useSelector((s: RootState) => s.auth.token);

  if (!token) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};


